import React from 'react'
import GeneralDetailsTab1 from './GeneralDetailsTab1'
import DescriptionTab1 from './DescriptionTab1'
import Table1 from './Table1'
import Table2 from './Table2'

function Tab1({ formData, onFieldChange, extraData }) {
    console.log(extraData, "extraData-check");

    return (

        <div className="px-4 py-4" style={{ background: 'white' }}>
            <GeneralDetailsTab1
                formData={formData}
                onFieldChange={onFieldChange}
                extraData={extraData}
            />
            <Table1
                
                title="Units of Measure"
                extradata={extraData}
                columns={extraData.ItemColumnsTab1Table1}
                rows={[]}
                setRows={() => { }}
                list_data={() => { }}
                status={""}
            />
            <Table2
                title="Taxes and Charges"
                 extradata={extraData}
                columns={extraData.ItemColumnsTab1Table2}
                rows={[]}
                setRows={() => { }}
                list_data={() => { }}
                status={""}
            />

            
            <DescriptionTab1
                formData={formData}
                onFieldChange={onFieldChange}
                extraData={extraData}
            />
        </div>

    )
}

export default Tab1
